import * as React from "react";
import * as ReactDOM from "react-dom";

import UnifiedPublishingAlert from "../UnifiedPublishingAlert";

// For hot reloading
declare var module: any;
if (module.hot) {
  module.hot.accept();
}

// Doing this with plain old JS (not JQuery) to avoid dependency on JQuery.
const components = document.getElementsByClassName("unifiedPublishingAlertComponent");

for (let i = 0; i < components.length; i++) { // tslint:disable-line prefer-for-of

  const elem = components[i];
  const portletInstanceId: number = elem.attributes["data-portlet-instance-id"].nodeValue;

  const render = (Component) => {
    ReactDOM.render(
      <Component portletInstanceId={portletInstanceId} />,
      elem,
    );
  };

  render(UnifiedPublishingAlert);
}
